import { render } from "./ErpInvoice.vue?vue&type=template&id=ec9de6a2&scoped=true"
import script from "./ErpInvoice.vue?vue&type=script&lang=js"
export * from "./ErpInvoice.vue?vue&type=script&lang=js"

import "./ErpInvoice.vue?vue&type=style&index=0&id=ec9de6a2&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec9de6a2"]])

export default __exports__